import React, { useEffect, useState } from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { withRouter } from "../../_shared/withRouter";
import InputComponent from "../_common/inputComponent";
import { globalAlert, globalLoader } from "../../actions/commonActions";
import { fetchUserProfileStorage, userEligibleTransactionApi, userOrderProductApi } from "../../user/_userActions";
import { logOut } from "../../_shared/commonFunction";
import CountdownTimer from "./countdownTimer";
import TransactionDetails from "./transactionDetails";
import TransactionConfirm from "./transactionConfirm";
import { useTranslation } from "react-i18next";

const UserOrderModel = ({ open, orderProduct, closeModal, closeOrderModal, props }) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    street: "",
    addressLine2: "",
    town: "",
    postcode: "",
    contact: "",
  });

  const [errors, setErrors] = useState({});
  const [showForm, setShowForm] = useState(false);
  const [reviewPage, setReviewPage] = useState(false);
  const [transactionStatus, setTransactionStatus] = useState(false);
  const [transactionMsg, setTransactionMsg] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState(null);
  const [pendingScreenMsg, setPendingScreenMsg] = useState("");
  const [transactionDetails, setTransactionDetails] = useState(null);

  const callBasicApi = async () => {
    try {
      globalLoader(true);
      let res = await userEligibleTransactionApi();
      if (res?.data?.status === 200) {
        if (res?.data?.data?.transactionDetails)
          setTransactionDetails(res?.data?.data?.transactionDetails);
        if (res?.data?.data?.isEligible) {
          setShowForm(true);
          const profile = fetchUserProfileStorage();
          if(profile){
            setFormData({
              ...formData,
              contact: profile?.mobile || formData?.contact,
              postcode: profile?.postalCode || formData?.postcode,
            });
          }

        } else {
          if (res?.data?.data?.pendingScreen) {
            setPendingScreenMsg(res?.data?.data?.message);
          } else {
            setTimeRemaining(res?.data?.data);
          }
        }
      } else {
        globalAlert("error", res?.data?.message);
      }
      globalLoader(false);
    } catch (error) {
      globalAlert("error", error?.response?.data?.message);
      if (error?.response?.data?.status === 400) {
        logOut(props?.history, "/user/login");
      }
      globalLoader(false);
    }
  };

  useEffect(() => {
    if (open) {
      callBasicApi();
    }
  }, [open]);
  const handleChange = (name, value) => {
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: false });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = {};
    Object.entries(formData).forEach(([key, value]) => {
      if (!value) {
        newErrors[key] = true;
      }
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    // Submit logic here
    console.log("Form submitted", formData);
    // show review screen
    setReviewPage(true);
    // closeModal();
  };

  const handleApiSubmit = async () => {
    // call api to save this data
    globalLoader(true);
    let res = await userOrderProductApi({ street: formData?.street, address: formData?.addressLine2, city: formData?.town, orgProductId: orderProduct?.orgProductId });
    if (res?.data?.status === 200) {
      setReviewPage(false);
      setTransactionStatus(true);
      setTransactionMsg(res?.data?.data?.message);
    } else {
      globalAlert("error", res?.data?.message);
    }
    globalLoader(false);
  }

  return (
    <Modal
      open={open}
      onClose={closeModal} // ✅ Correct
      showCloseIcon={true} // ✅ Shows close icon (optional, true by default)
      closeIcon={
        <span style={{ color: "black", fontSize: "24px", marginTop: "-10px" }}>
          ✖
        </span>
      }
      center
      classNames={{ modal: "admin-modal" }}
    >
      {!showForm ? (
        <>
          {pendingScreenMsg ? (
            <div className="d-flex flex-column align-items-center pending-message text-color-primary col-12 pt-4 text-center">
              {pendingScreenMsg}
              <button className="btn secondary-btn footer-width py-2 px-2" onClick={closeModal}>
                    {t("user.order.close")}
                  </button>
            </div>
          ) : (
            timeRemaining && <section style={{ marginTop: "16px" }}>
              <CountdownTimer
                timeRemaining={timeRemaining}
                callBack={setShowForm}
              />

              {transactionDetails && transactionDetails?.show && (
                <TransactionDetails
                  transactionDetails={transactionDetails?.details}
                />
              )}
            </section>
          )}
        </>
      ) : (
        <>
        {reviewPage ? (
          <>
          <div className="d-flex flex-column align-items-center">
            <h6 className="text-center fw-bold mb-4">{t("user.order.confirmDeliveryInfo")}</h6>

            <img src={`${orderProduct?.image}`} alt={`${orderProduct?.name}`} className="product-img mx-auto" />
            <div className="product-details mx-3">
              <p className="fw-bold fs-5 mb-2">{orderProduct?.name}</p>
              <p className="text-secondary">{orderProduct?.description}</p>
            </div>
            <div className="d-flex justify-content-between mt-4 mx-auto" style={{width: "fit-content", gap: "10px"}}>
              <button
                className="btn primary-btn footer-width py-2 px-2"
                onClick={() => setReviewPage(false)}
              >
                {t("user.order.goBack")}
              </button>
              <button
                className="btn secondary-btn footer-width py-2 px-2"
                onClick={() => handleApiSubmit()}
              >
                {t("user.order.confirm")}
              </button>
            </div>

          </div>
          </>
        ) : (transactionStatus && transactionMsg) ? (
          <div className="success-screen text-center d-flex flex-column align-items-center">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h5 className="fw-bold fs-5 mb-0 mt-2">{t("user.order.transactionSuccessful")}</h5>
            </div>
            <div className="collapse-wrapper">
              <div className="collapse show" id="collapseExample">
                <div className="collapse-body">
                  <h6 className="fw-bold fs-5 mb-4">{transactionMsg}</h6>
                  <button className="btn secondary-btn footer-width py-2 px-2" onClick={closeModal}>
                    {t("user.order.close")}
                  </button>
                </div>
              </div>
            </div>

          </div>
        ) : (
          <>
          <p className="text-center fw-bold fs-5 mb-3 mt-4">
            {t("user.order.provideAddress")}
          </p>
          <form onSubmit={handleSubmit} className="form-own px-3">
            <div className="mb-2">
              <InputComponent
                placeholder={t("user.order.streetPlaceholder")}
                label={t("user.order.streetLabel")}
                type="text"
                name="street"
                value={formData.street}
                handleCallback={(val) => handleChange("street", val)}
              />
              {errors.street && (
                <span className="error-text">{t("user.order.streetRequired")}</span>
              )}
            </div>

            <div className="mb-2">
              <InputComponent
                placeholder={t("user.order.addressPlaceholder")}
                label={t("user.order.addressLabel")}
                type="text"
                name="addressLine2"
                value={formData.addressLine2}
                handleCallback={(val) => handleChange("addressLine2", val)}
              />
              {errors.addressLine2 && (
                <span className="error-text">{t("user.order.addressRequired")}</span>
              )}
            </div>

            <div className="mb-2">
              <InputComponent
                placeholder={t("user.order.townPlaceholder")}
                label={t("user.order.townLabel")}
                type="text"
                name="town"
                value={formData.town}
                handleCallback={(val) => handleChange("town", val)}
              />
              {errors.town && (
                <span className="error-text">{t("user.order.townRequired")}</span>
              )}
            </div>

            <div className="mb-2">
              <InputComponent
                placeholder={t("user.order.postcodePlaceholder")}
                label={t("user.order.postcodeLabel")}
                type="text"
                name="postcode"
                value={formData.postcode}
                disabled
                handleCallback={(val) => handleChange("postcode", val)}
              />
              {errors.postcode && (
                <span className="error-text">{t("user.order.postcodeRequired")}</span>
              )}
            </div>

            <div className="form-own-group mb-3">
              <InputComponent
                placeholder={t("user.order.contactPlaceholder")}
                label={t("user.order.contactLabel")}
                type="text"
                name="contact"
                value={formData.contact}
                disabled
                handleCallback={(val) => handleChange("contact", val)}
              />
              {errors.contact && (
                <span className="error-text">{t("user.order.contactRequired")}</span>
              )}
            </div>

            <button type="submit" className="btn btn-primary w-100">
              {t("user.order.continueButton")}
            </button>
          </form>
          </>
        )}
        </>
      )}
    </Modal>
  );
};

export default withRouter(UserOrderModel);
